import { Workshop } from "../types/workshops"
import { FetchFromBackoffice } from "../utils/requests"
import { PostToBackoffice } from "../utils/commands"

export type WorkshopArea = {
  name: string;
}

export type WorkshopAreasResponse = {
  workshopId: string;
  items: WorkshopArea[];
}

export const fetchWorkshops = () => FetchFromBackoffice<Workshop[]>(`portal/workshop`)

export const fetchWorkshopAreas = (workshopId: string) =>
  FetchFromBackoffice<WorkshopAreasResponse>(`portal/workshops/${workshopId}/areas`)

export const addWorkshopArea = (workshopId: string, areaName: string) =>
  PostToBackoffice('cmd/Workshop/Area/Add', { workshopId, areaName })

export const removeWorkshopArea = (workshopId: string, areaName: string) =>
  PostToBackoffice('cmd/Workshop/Area/Remove', { workshopId, areaName })